// src/pages/TrackCreation/DescriptionScreen.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import TitleSubtitle from "../../../../components/common/TitleSubtitle";
import TextInput from "../../../../components/ui/TextInput";
import { useTrackCreation } from "../../../../context/TrackCreationContext";
import Button from "../../../../components/ui/Button";
import { DescriptionScreenProps } from "../../../../types/screensTypes";
import stepStyles from "../createStep.module.css";

const DescriptionScreen: React.FC<DescriptionScreenProps> = ({ navigateToNext }) => {
    const { trackData, updateTrackData } = useTrackCreation();
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    // Update a specific line of highlights
    const handleHighlightChange = (index: number, value: string): void => {
        const highlightsArray = (trackData.highlights || "").split("\n");
        highlightsArray[index] = value; // Update the specific line
        updateTrackData("highlights", highlightsArray.join("\n")); // Join back into a string
    };

    return (
        <div className={`step-container ${stepStyles.stepContainer} ${stepStyles.step}`}>
            <TitleSubtitle
                title={t("subtitle")}
                subtitle={t("giveTheCustomerATasteOfWhatTheyllListenWithAShortSubtitleIn1Sentence")}
                layout="step"
            />

            <div className={stepStyles.stepDescription}>
                <TextInput
                    placeholder={t("pleaseEnterADescription")}
                    value={trackData.subtitle || ""}
                    onChange={(e) => updateTrackData("subtitle", e.target.value)}
                    size="big"
                    numberOfLines={6}
                />
            </div>

            <TitleSubtitle
                title={t("addAFullDescription")}
                subtitle={t("provideAllTheDetailsAboutWhatTheCustomerWillSeeAndListenDuringTheAudioTour")}
                tooltip={t("doNotTranslateTooltip")}
                layout="step"
            />

            <div className={stepStyles.stepDescription}>
                <TextInput
                    placeholder={t("pleaseInsertYourText")}
                    value={trackData.description || ""}
                    onChange={(e) => updateTrackData("description", e.target.value)}
                    size="big"
                    numberOfLines={6}
                />
            </div>

            <TitleSubtitle
                title={t("summariesTheHighlights")}
                subtitle={t("writeThreeToFiveSentencesExplainingWhatMakesYourAudioTourSpecial")}
                layout="step"
            />

            <div className={stepStyles.highlightInputs}>
                {Array(3)
                    .fill("")
                    .map((_, index) => {
                        const highlights = (trackData.highlights || "").split("\n");
                        return (
                            <TextInput
                                key={index}
                                placeholder={`${t("highlightWithSemiColumn")}${index + 1}`}
                                value={highlights[index] || ""}
                                onChange={(e) => handleHighlightChange(index, e.target.value)}
                                size="medium"
                            />
                        );
                    })}
            </div>

            <div className={`${stepStyles.stepButton} ${stepStyles.footer}`}>
                <Button
                    label={t("continue")}
                    onClick={navigateToNext}
                    disabled={!trackData.subtitle || !trackData.highlights}
                    variant="primary"
                    shape="pill"
                    className={stepStyles.continueBtn}
                    showError={() => console.log("error")}
                />
            </div>
        </div>
    );
};

export default DescriptionScreen;
